import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { capitalize } from 'swag-common/utils/strings';
import { Price } from 'swag-client-common/utils/price';
import { accumulatorCheck } from 'swag-common/utils/product/product.utils';
import placeholderImage from 'assets/img/placeholder.png';
import SearchPatagoniaCard from '../search-patagonia-card';
import classes from './search-results.scss';
const renderSearchResults = (searchResults, onLinkClick) => {
  const list = searchResults.map(product => {
    const {
      _id,
      name,
      link,
      logo,
      minQuant,
      minPriceToUse,
      maxPriceToUse,
      limitedEdition
    } = product;
    const isAccumulator = accumulatorCheck(product);
    const isLimitedEdition = limitedEdition === null || limitedEdition === void 0 ? void 0 : limitedEdition.isLimitedEdition;
    return isAccumulator ? /*#__PURE__*/React.createElement(SearchPatagoniaCard, {
      product: product,
      onLinkClick: onLinkClick
    }) : /*#__PURE__*/React.createElement(Link, {
      key: _id,
      onClick: onLinkClick,
      to: link,
      className: classnames(classes.row, {
        [classes.isLE]: isLimitedEdition
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.narrowCell
    }, /*#__PURE__*/React.createElement("img", {
      className: classes.searchImage,
      src: logo || placeholderImage,
      alt: "Product logo"
    }), isLimitedEdition && /*#__PURE__*/React.createElement("div", {
      className: classes.limitedEditionLabel
    }, "Limited Edition")), /*#__PURE__*/React.createElement("div", {
      className: classes.cell
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.productName, classes.textEllipsis)
    }, capitalize(name)), /*#__PURE__*/React.createElement("div", {
      className: classes.textEllipsis
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.lightGreyText
    }, "From\xA0"), /*#__PURE__*/React.createElement("span", {
      className: classes.text
    }, Price.formatPrice(minPriceToUse)), /*#__PURE__*/React.createElement("span", {
      className: classes.lightGreyText
    }, "\xA0to\xA0"), /*#__PURE__*/React.createElement("span", {
      className: classes.text
    }, Price.formatPrice(maxPriceToUse))), /*#__PURE__*/React.createElement("div", {
      className: classes.textEllipsis
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.minQuant
    }, "Min Qty:"), ' ', /*#__PURE__*/React.createElement("span", {
      className: classes.text
    }, minQuant))));
  });
  return list;
};
const renderSearchSuggestions = (searchSuggestions = [], onSuggestionClick) => {
  return /*#__PURE__*/React.createElement("ul", {
    className: classes.searchSuggestionsList
  }, /*#__PURE__*/React.createElement("li", {
    className: classes.searchSuggestionsText
  }, "Search Suggestions"), searchSuggestions.map(s => /*#__PURE__*/React.createElement("li", {
    className: classes.searchSuggestionsItem,
    key: s._id,
    onClick: () => onSuggestionClick({
      target: {
        value: s.name
      }
    })
  }, s.name)));
};
const showAllButton = (total, onButtonClick) => /*#__PURE__*/React.createElement("div", {
  className: classes.submitContainer
}, /*#__PURE__*/React.createElement("button", {
  className: classes.submit,
  onClick: onButtonClick
}, "Show All ", total, " Results"));
const SearchResults = ({
  searchResults,
  total,
  className = '',
  onLinkClick,
  onButtonClick,
  searchSuggestions,
  onSuggestionClick
}) => {
  const isSearchResultsExists = searchResults.length > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, searchResults.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classnames(className, classes.scrollWrapper)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.titleWrapper)
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.title
  }, "Search Results:"))), /*#__PURE__*/React.createElement("div", {
    className: classes.searchContainer
  }, renderSearchResults(searchResults, onLinkClick))), isSearchResultsExists && showAllButton(total, onButtonClick)) : /*#__PURE__*/React.createElement("div", {
    className: classnames(className, classes.scrollWrapperSearchSuggestions)
  }, renderSearchSuggestions(searchSuggestions, onSuggestionClick)));
};
SearchResults.defaultProps = {
  searchResults: []
};
export { SearchResults };